import '../App.css';
import Swal from 'sweetalert2';
import Footer from './Footer';
import { useState, useEffect } from "react";
import InventarioProducts from '../services/InventarioProducts';
import CrearProducts from '../services/CrearProducts';
import GeneralInfo from './GeneralInfo';
import img from '../assets/images/Product.svg';
import img2 from '../assets/images/Sales.svg';
import img3 from '../assets/images/Checking.svg';
import img4 from '../assets/images/Update-amico.svg';
import img5 from '../assets/images/404 Error-bro.svg';
import NewProduct from './NewProduct';


function Inventario() {

    const [toggleState, setToggleState] = useState(1);

    const toggleTab = (index) => {
      setToggleState(index);
    };

    const cerrarSesion=()=>{
        Swal.fire({
            title: 'Quieres cerrar sesion?',
            imageUrl: 'https://cdn-icons-png.flaticon.com/128/2550/2550435.png',
            showDenyButton: true,
            confirmButtonText: 'Si',
            denyButtonText: `No`,
        }).then((result) => {
            if (result.isConfirmed) {
                localStorage.removeItem('AuthId');
                localStorage.removeItem('UrlGoogle');
                window.location.href = '/micarrito';
            } else if (result.isDenied) {
              Swal.fire('', '', 'info')
            }
        })
    }

    const redireccionar=()=>{
        Swal.fire({
            title: 'Quieres mantener tu sesion abierta en este dispositivo?',
            imageUrl: 'https://cdn-icons-png.flaticon.com/128/3518/3518672.png',
            showDenyButton: true,
            confirmButtonText: 'Si',
            denyButtonText: `No cerrar`,
        }).then((result) => {
            if (result.isConfirmed) {
                window.location.href='/';
            } else if (result.isDenied) {
                localStorage.removeItem('AuthId');
                localStorage.removeItem('UrlGoogle');
                window.location.href = '/micarrito';
                window.location.href='/';
            }
        })
    }

    return (
        <>
            <header className="header-other">

                <main className='flex justify-between mx-auto max-w-7xl px-4 sm:static sm:px-6 lg:px-8'>

                    <h2 onClick={()=> redireccionar()} className='text-4xl font-bold tracking-tight text-[#fb8cff] cursor-pointer'>
                        ShaBless
                        <sub className='text-4xl font-bold tracking-tight'>Inventario</sub>
                    </h2>

                    <img src={localStorage.getItem('UrlGoogle')} className='img-auth' alt="" onClick={()=> cerrarSesion()}/>
                    
                </main>   

            </header>

            <br/><br/><br/><br/>

            <NewProduct/>

            <div className="container-tabs">

                <section className='title'>
                    <h1>Almacen Controls</h1>
                    <img src={require('../assets/images/quality-control.png')} alt="" />
                </section>
                    
                <div className="bloc-tabs">
                    <article
                        className={toggleState === 1 ? "tabs active-tabs" : "tabs"}
                        onClick={() => toggleTab(1)}
                    >
                        <img src={img} alt="" />
                        <p>Subir Producto</p>
                    </article>
                    <article
                        className={toggleState === 2 ? "tabs active-tabs" : "tabs"}
                        onClick={() => toggleTab(2)}
                    >
                        <img src={img3} alt="" />
                        <p>Inventario</p>
                    </article>
                    <article
                        className={toggleState === 3 ? "tabs active-tabs" : "tabs"}
                        onClick={() => toggleTab(3)}
                    >
                        <img src={img2} alt="" />
                        <p>Historial de Ventas</p>
                    </article>
                    <article
                        className={toggleState === 4 ? "tabs active-tabs" : "tabs"}
                        onClick={() => toggleTab(4)}
                    >
                        <img src={img4} alt="" />
                        <p>General</p>
                    </article>
                </div>
        
                <div className="content-tabs">
                    <div
                        className={toggleState === 1 ? "content  active-content" : "content"}
                    >
                        <CrearProducts/>
                    </div>
        
                    <div
                        className={toggleState === 2 ? "content  active-content" : "content"}
                    >
                        <InventarioProducts/>
                    </div>
        
                    <div
                        className={toggleState === 3 ? "content  active-content" : "content"}
                    >
                        <section style={{textAlign:'center'}}>
                            <img src={img5} alt=""/>
                        </section>
                    </div>

                    <div
                        className={toggleState === 4 ? "content  active-content" : "content"}
                    >
                        <GeneralInfo/>
                    </div>

                </div>

            </div>

            <Footer/>
        </>
    )
}

export default Inventario
